module.exports = __webpack_public_path__ + "static/media/fmb204-ip67-and-li-ion-back-up-battery-6.ddba743c.png";